module.exports = __webpack_public_path__ + "static/media/users-icon.7f6c7920.svg";